export enum ACCOUNT_REFILLING {
    FINISH = 3,
    PARTIAL = 2,
    UNFINISH = 1,
}
